import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2021 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_03, PROMETHEAN_TYPOGRAPHY_BODY } from '../styles/typography/typography';
import { PROMETHEAN_NEUTRAL_DARK_GREY } from '../styles/colors/colors';
export var StyledInfoList = styled('div')({
  '&.EmbersInfoList-root': {
    '.EmbersInfoList-item': _objectSpread(_objectSpread({
      display: 'flex',
      columnGap: '8px',
      borderBottom: "1px solid ".concat(PROMETHEAN_NEUTRAL_DARK_GREY),
      padding: '8px 0'
    }, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
      '.info-label': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_03), {}, {
        width: '180px',
        marginLeft: 16,
        flexShrink: 0,
        wordBreak: 'break-word',
        '&.info-label-withTooltip': {
          display: 'flex',
          alignItems: 'center',
          columnGap: '4px',
          i: {
            lineHeight: '24px'
          }
        }
      }),
      '.info-content': {
        wordBreak: 'break-word'
      }
    })
  }
});